import Vue from 'vue';
import 'vant/lib/index.css';

import { Loading, DropdownMenu, DropdownItem } from 'vant';

Vue.use(Loading).use(DropdownMenu).use(DropdownItem);
